<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="amzSkuStoreCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true  }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.v_sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus || '未配置状态' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span
        ><span style="color: #303133">{{ row.amzGoodsSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displaySpu="{ row }">
        <span>{{ $l('table_label_SPU') || 'SKU' }}：</span>
        <span style="color: #303133">{{ row.amzSpuNo }}</span>
        <br />
        <span>{{ $l('table_label_collectionName') || '系列' }}：</span>
        <span style="color: #303133">{{ row.collectionName }}</span>
        <br />
        <span>{{ $l('table_label_collectionNameCn') || '中文系列' }}：</span>
        <span style="color: #303133">{{ row.collectionNameCn }}</span>
        <br />
        <span>{{ $l('table_label_categoryFullName') || '品类' }}：</span>
        <span style="color: #303133">{{ row.categoryFullName }}</span>
        <br v-if="row.isFocus == 'Y'" />
        <el-tag
          type="warning"
          effect="plain"
          size="mini"
          v-if="row.isFocus == 'Y'"
        >
          {{ $l('table_text_isFocus') || '重点关注' }}
        </el-tag>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC：{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span v-if="!row.salesUrl">{{ row.salesTitle }}</span>
        <el-link
          v-if="!!row.salesUrl"
          type="primary"
          :href="row.salesUrl"
          :underline="false"
          target="_blank"
        >
          {{ row.salesTitle }}
        </el-link>
        <br />
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>ASIN：</span
        ><span style="color: #409EFF">{{ row.asinCode }}</span>
        <br />
        <span>FNSKU：</span
        ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
        <br />
        <span>UPC：</span
        ><span style="color: #409EFF">{{ row.upc }}</span>
      </template>
      <template v-slot:displayStore="{ row }">
        <span>SHOP：</span
        ><span style="color: #303133">{{ row.amzStoreName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.storeBrandName }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_sellType"
            size="mini"
            :type="
              row.sellType === 'B'
                ? ''
                : row.sellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_sellType || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.storeSkuStatus === 'Y'
                ? 'success'
                : row.storeSkuStatus === 'S' ||
                  row.storeSkuStatus === 'B' ||
                  row.storeSkuStatus === 'W'
                ? 'danger'
                : row.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_storeSkuStatus || '未配置状态' }}
          </el-tag>
        </div>
        <span>CPFR：</span>
        <el-tag
          :type="row.noMoreReplenishment === 'N' ? 'success' : 'danger'"
          size="mini"
          v-if="!!row.noMoreReplenishment"
        >
          {{
            row.noMoreReplenishment == 'Y'
              ? $l('tag_view_noRestocking') || '不补货'
              : $l('tag_view_restocking') || '补货'
          }}
        </el-tag>
        <br />
        <span>{{ $l('table_label_attributes') || '属性' }}：</span
        ><span style="color: #303133">{{ row.goodsProperties }}</span>
      </template>
      <template v-slot:displayPrice="{ row }">
        <span>{{ row.v_salesPrice }}</span>
        <br />
        <span>{{ $l('table_label_fbaDeliveryFee') || 'FBA配送费' }}：</span>
        <span>{{ format(row.fbaDeliveryFee) || '0' }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format: (n) => format(n),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    removeCheckboxRow() {
      this.$refs.listingTable.clearCheckboxRow()
      this.$refs.listingTable.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.listingTable
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    // handleCommand({ storeCode, amzSkuStoreCode }) {
    //   this.$emit('showDetail', { storeCode, amzSkuStoreCode })
    // },

    handleCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      const { storeCode, amzSkuStoreCode } = data
      switch (menuType) {
        case 'detail':
          this.$emit('showDetail', {
            storeCode,
            amzSkuStoreCode,
            disabled: true,
            title: '上架信息',
          })
          break
        case 'edit':
          this.$emit('showDetail', {
            storeCode,
            amzSkuStoreCode,
            disabled: false,
            title: this.$l('dialog_title_update_sku') || '修改SKU',
          })
          break
        case 'availableSale':
          this.$confirm(
            this.$l('tips_confirm_availableSale') ||
              '是否要将选择中的记录修改为可售',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText:
                this.$l('INDEX.product_dialog_btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          ).then(() => {
            this.$emit('storeAvailableSaleApi', [amzSkuStoreCode])
          })
          break
        case 'unsaleable':
          this.$confirm(
            this.$l('tips_confirm_unsaleable') ||
              '是否要将选择中的记录修改为不可售',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText:
                this.$l('INDEX.product_dialog_btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          ).then(() => {
            this.$emit('skuStoreUnsaleableApi', [amzSkuStoreCode])
          })
          break
        case 'noRestocking':
          this.$confirm(
            this.$l('tips_confirm_noRestocking') ||
              '是否要将选择中的记录修改为不补货',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText:
                this.$l('INDEX.product_dialog_btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          ).then(() => {
            this.$emit('skuStoreUnrestockingApi', [amzSkuStoreCode])
          })
          break
        case 'restocking':
          this.$confirm(
            this.$l('tips_confirm_restocking') ||
              '是否要将选择中的记录修改为可补货',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText:
                this.$l('INDEX.product_dialog_btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          ).then(() => {
            this.$emit('skuStoreRestockingApi', [amzSkuStoreCode])
          })
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
  },
}
</script>
